import {
  borderStyles,
  colors,
  cornerRadius,
  spacing,
  styled,
} from "../../../stitches.config";

export const InlineBlock = styled("div", {
  display: "inline-block",
});

const gapVariants = {
  "2xs": {
    gap: spacing["2xs"],
  },
  xs: {
    gap: spacing.xs,
  },
  s: {
    gap: spacing.s,
  },
  m: {
    gap: spacing.m,
  },
  l: {
    gap: spacing.l,
  },
  xl: {
    gap: spacing.xl,
  },
  "2xl": {
    gap: spacing["2xl"],
  },
  "3xl": {
    gap: spacing["3xl"],
  },
};

export const FlexRow = styled("div", {
  display: "flex",
  flexDirection: "row",

  variants: {
    gap: gapVariants,
  },
});

export const FlexColumn = styled("div", {
  display: "flex",
  flexDirection: "column",

  variants: {
    gap: gapVariants,
  },
});

export const Row = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "row",
  padding: "12px 0",
});

export const Col = styled("div", {
  flexBasis: 0,
  flexGrow: 1,
  maxWidth: "100%",
  boxSizing: "border-box",
  padding: "0 12px",
});

export const Grid = styled("div", {
  margin: "-12px",
});

export const Box = styled("div", {
  border: borderStyles.solid,
  borderRadius: cornerRadius.radiusSm,
  boxShadow: "0 2px 4px rgba(221, 221, 221, 0.5)",
  background: colors.bgUiSurface,
});

export const StyledSections = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: spacing.l,
});

export const StyledSection = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: spacing.m,
});

export const CenterContent = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flex: 1,
});

export const StyledGrid = styled("div", {
  display: "grid",
  width: "100%",
  boxSizing: "border-box",
  alignItems: "start",
  justifyItems: "start",
});
